module.exports = __webpack_public_path__ + "static/img/高纯度.368119b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/metallurgy/高纯度.jpg
// module id = ekyV
// module chunks = 1